// import React, { useState, useEffect } from "react";
// import "./Jogos.css";
// import Header from "./Header";
// import Footer from "./Footer";

// // ========================== COMPONENTES AUXILIARES ==========================

// // Seletor de dificuldade
// const DifficultySelector = ({ setDifficulty, difficulty }) => (
//   <div className="difficulty-selector">
//     {["facil", "medio", "dificil"].map((level) => (
//       <button
//         key={level}
//         onClick={() => setDifficulty(level)}
//         className={`difficulty-btn ${difficulty === level ? "active" : ""}`}
//       >
//         {level.toUpperCase()}
//       </button>
//     ))}
//   </div>
// );

// // Menu inicial
// const GameMenu = ({ setGame, setDifficulty, difficulty, score }) => (
//   <div className="game-menu">
//     <h2>🎮 Jogos Educativos</h2>
//     <p className="score">⭐ Pontos: <b>{score}</b></p>
//     <DifficultySelector setDifficulty={setDifficulty} difficulty={difficulty} />

//     <div className="menu-buttons">
//       <button onClick={() => setGame("anagram")} className="btn blue">🔤 Anagramas</button>
//       <button onClick={() => setGame("crossword")} className="btn green">🧩 Palavras Cruzadas</button>
//       <button onClick={() => setGame("crossmath")} className="btn red">➕ CrossMath</button>
//       <button onClick={() => setGame("ranking")} className="btn purple">🏆 Ranking</button>
//     </div>
//   </div>
// );

// // ========================== JOGOS ==========================

// // 1) Anagramas
// const words = {
//   facil: ["casa", "pato", "bola"],
//   medio: ["escola", "amigos", "planta"],
//   dificil: ["computador", "linguagem", "javascript"],
// };

// const AnagramGame = ({ difficulty, onBack, addPoints }) => {
//   const [word] = useState(() => {
//     const list = words[difficulty];
//     return list[Math.floor(Math.random() * list.length)];
//   });
//   const [input, setInput] = useState("");
//   const [message, setMessage] = useState("");
//   const [done, setDone] = useState(false);

//   const shuffled = word.split("").sort(() => Math.random() - 0.5).join("");

//   const checkAnswer = () => {
//     if (done) return;
//     if (input.toLowerCase() === word) {
//       setMessage("✅ Correto! +10 pontos");
//       addPoints(10);
//       saveToRanking(10);
//       setDone(true);
//     } else {
//       setMessage("❌ Tente novamente.");
//     }
//   };

//   const saveToRanking = (points) => {
//     let ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
//     ranking.push({ name: "Jogador", points });
//     localStorage.setItem("ranking", JSON.stringify(ranking));
//   };

//   return (
//     <div className="game">
//       <h3>🔤 Anagrama</h3>
//       <p>Reorganize as letras: <b>{shuffled}</b></p>
//       <input
//         type="text"
//         value={input}
//         onChange={(e) => setInput(e.target.value)}
//         className="input"
//       />
//       <button onClick={checkAnswer} className="btn blue">Verificar</button>
//       <p>{message}</p>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // 2) Palavras Cruzadas
// const puzzles = {
//   facil: { word: "sol", hint: "Brilha no céu" },
//   medio: { word: "caderno", hint: "Usado para escrever" },
//   dificil: { word: "programador", hint: "Quem cria software" },
// };

// const CrosswordGame = ({ difficulty, onBack, addPoints }) => {
//   const puzzle = puzzles[difficulty];
//   const [letters, setLetters] = useState(Array(puzzle.word.length).fill(""));
//   const [message, setMessage] = useState("");
//   const [done, setDone] = useState(false);

//   const checkAnswer = () => {
//     if (done) return;
//     if (letters.join("").toLowerCase() === puzzle.word) {
//       setMessage("✅ Correto! +10 pontos");
//       addPoints(10);
//       saveToRanking(10);
//       setDone(true);
//     } else {
//       setMessage("❌ Ainda não está certo.");
//     }
//   };

//   const saveToRanking = (points) => {
//     let ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
//     ranking.push({ name: "Jogador", points });
//     localStorage.setItem("ranking", JSON.stringify(ranking));
//   };

//   return (
//     <div className="game">
//       <h3>🧩 Palavras Cruzadas</h3>
//       <p>Dica: {puzzle.hint}</p>
//       <div className="crossword">
//         {letters.map((letter, i) => (
//           <input
//             key={i}
//             value={letter}
//             onChange={(e) => {
//               const newLetters = [...letters];
//               newLetters[i] = e.target.value.slice(-1);
//               setLetters(newLetters);
//             }}
//             maxLength={1}
//             className="crossword-cell"
//           />
//         ))}
//       </div>
//       <button onClick={checkAnswer} className="btn green">Verificar</button>
//       <p>{message}</p>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // 3) CrossMath
// const mathPuzzles = {
//   facil: { a: 2, b: 3, result: 5, op: "+" },
//   medio: { a: 8, b: 4, result: 32, op: "×" },
//   dificil: { a: 15, b: 3, result: 5, op: "÷" },
// };

// const CrossMathGame = ({ difficulty, onBack, addPoints }) => {
//   const puzzle = mathPuzzles[difficulty];
//   const [input, setInput] = useState("");
//   const [message, setMessage] = useState("");
//   const [done, setDone] = useState(false);

//   const checkAnswer = () => {
//     if (done) return;
//     if (parseInt(input) === puzzle.result) {
//       setMessage("✅ Correto! +10 pontos");
//       addPoints(10);
//       saveToRanking(10);
//       setDone(true);
//     } else {
//       setMessage("❌ Errado, tente novamente.");
//     }
//   };

//   const saveToRanking = (points) => {
//     let ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
//     ranking.push({ name: "Jogador", points });
//     localStorage.setItem("ranking", JSON.stringify(ranking));
//   };

//   return (
//     <div className="game">
//       <h3>➕ CrossMath</h3>
//       <p>Resolva: {puzzle.a} {puzzle.op} {puzzle.b} = ?</p>
//       <input
//         type="number"
//         value={input}
//         onChange={(e) => setInput(e.target.value)}
//         className="input"
//       />
//       <button onClick={checkAnswer} className="btn red">Verificar</button>
//       <p>{message}</p>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // 4) Ranking
// const Ranking = ({ onBack }) => {
//   const [ranking, setRanking] = useState([]);

//   useEffect(() => {
//     let data = JSON.parse(localStorage.getItem("ranking") || "[]");
//     let scores = {};
//     data.forEach(r => {
//       scores[r.name] = (scores[r.name] || 0) + r.points;
//     });
//     let sorted = Object.entries(scores)
//       .map(([name, points]) => ({ name, points }))
//       .sort((a, b) => b.points - a.points)
//       .slice(0, 5);
//     setRanking(sorted);
//   }, []);

//   return (
//     <div className="game">
//       <h3>🏆 Ranking</h3>
//       <ol>
//         {ranking.map((r, i) => (
//           <li key={i}><b>{i + 1}. {r.name}</b> — {r.points} pts</li>
//         ))}
//       </ol>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // ========================== PÁGINA PRINCIPAL ==========================

// const Jogos = () => {
//   const [game, setGame] = useState(null);
//   const [difficulty, setDifficulty] = useState("facil");
//   const [score, setScore] = useState(0);

//   useEffect(() => {
//     const saved = localStorage.getItem("score");
//     if (saved) setScore(parseInt(saved));
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("score", score);
//   }, [score]);

//   const addPoints = (points) => setScore((prev) => prev + points);

//   const renderGame = () => {
//     switch (game) {
//       case "anagram":
//         return <AnagramGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />;
//       case "crossword":
//         return <CrosswordGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />;
//       case "crossmath":
//         return <CrossMathGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />;
//       case "ranking":
//         return <Ranking onBack={() => setGame(null)} />;
//       default:
//         return (
//           <GameMenu
//             setGame={setGame}
//             setDifficulty={setDifficulty}
//             difficulty={difficulty}
//             score={score}
//           />
//         );
//     }
//   };

//   return (
//     <div>
//       <Header />
//       <section className="jogos-section">
//         <div className="container">
//           {renderGame()}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default Jogos;

// kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk

// import React, { useState, useEffect } from "react";
// import "./Jogos.css";

// // importa os componentes existentes
// import Header from "./Header";
// import Footer from "./Footer";

// function Ranking({ score }) {
//   const [ranking, setRanking] = useState([]);

//   useEffect(() => {
//     const savedRanking = JSON.parse(localStorage.getItem("ranking")) || [];
//     setRanking(savedRanking);
//   }, []);

//   useEffect(() => {
//     if (score > 0) {
//       const newRanking = [...ranking, { score, date: new Date().toLocaleString() }];
//       localStorage.setItem("ranking", JSON.stringify(newRanking));
//       setRanking(newRanking);
//     }
//   }, [score]);

//   return (
//     <div className="ranking">
//       <h2>🏆 Ranking</h2>
//       <ul>
//         {ranking.map((r, i) => (
//           <li key={i}>
//             {r.score} pontos - {r.date}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// function PalavrasCruzadas({ onScore }) {
//   const niveis = {
//     facil: ["Povo", "Maputo", "Zambeze"],
//     medio: ["Gaza", "Niassa", "Lourenço", "Independência", "Charrua"],
//     dificil: [
//       "Samora Machel",
//       "FRELIMO",
//       "Ngungunhane",
//       "Colonialismo",
//       "Moçambique",
//       "Guerra Civil",
//       "Tratado de Lusaka",
//       "Resistência",
//       "Educação",
//     ],
//   };

//   return (
//     <div className="game-box">
//       <h3>🧩 Palavras Cruzadas</h3>
//       {Object.entries(niveis).map(([nivel, palavras]) => (
//         <div key={nivel}>
//           <h4>{nivel.toUpperCase()}</h4>
//           <ul>
//             {palavras.map((p, i) => (
//               <li key={i} onClick={() => onScore(10)}> {p} </li>
//             ))}
//           </ul>
//         </div>
//       ))}
//     </div>
//   );
// }

// function Anagramas({ onScore }) {
//   const desafios = [
//     { palavra: "MOPAUT", resposta: "MAPUTO" },
//     { palavra: "ILFREMO", resposta: "FRELIMO" },
//     { palavra: "ACNLOIISMOLO", resposta: "COLONIALISMO" },
//     { palavra: "ROMASA LEMACH", resposta: "SAMORA MACHEL" },
//   ];

//   return (
//     <div className="game-box">
//       <h3>🔀 Anagramas</h3>
//       {desafios.map((item, i) => (
//         <div key={i}>
//           <strong>{item.palavra}</strong> ➝ <em>{item.resposta}</em>
//           <button onClick={() => onScore(5)}>Acertar</button>
//         </div>
//       ))}
//     </div>
//   );
// }

// function CrossMaths({ onScore }) {
//   const niveis = {
//     facil: ["2 + 2 = 4", "5 - 3 = 2", "6 ÷ 2 = 3"],
//     medio: ["12 ÷ 3 + 2 = 6", "15 - 7 + 4 = 12", "3 × 4 - 5 = 7"],
//     dificil: ["(8 × 3) - (12 ÷ 4) = 22", "(25 ÷ 5) × 6 = 30", "40 - (3 × 7) = 19"],
//   };

//   return (
//     <div className="game-box">
//       <h3>➗ CrossMaths</h3>
//       {Object.entries(niveis).map(([nivel, contas]) => (
//         <div key={nivel}>
//           <h4>{nivel.toUpperCase()}</h4>
//           <ul>
//             {contas.map((c, i) => (
//               <li key={i} onClick={() => onScore(5)}>{c}</li>
//             ))}
//           </ul>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default function Jogos() {
//   const [score, setScore] = useState(0);

//   const addScore = (points) => {
//     setScore((prev) => prev + points);
//   };

//   return (
//     <div className="jogos-container">
//       <Header />
//       <Ranking score={score} />

//       <div className="games">
//         <PalavrasCruzadas onScore={addScore} />
//         <Anagramas onScore={addScore} />
//         <CrossMaths onScore={addScore} />
//       </div>

//       <Footer />
//     </div>
//   );
// }

// kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk


// // ========================= Jogos.jsx =========================
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import "./Jogos.css";
// import Header from "./Header";
// import Footer from "./Footer";
// // import CrosswordGame from "./CrosswordGame";

// // ========================== CONFIGURAÇÕES GERAIS ==========================
// const LEVEL_CONFIG = {
//   facil: { items: 4, seconds: 60 },
//   medio: { items: 6, seconds: 120 },
//   dificil: { items: 9, seconds: 300 },
//   complicado: { items: 12, seconds: 420 },
// };

// const DIFFICULTY_LABEL = {
//   facil: "FÁCIL",
//   medio: "MÉDIO",
//   dificil: "DIFÍCIL",
//   complicado: "COMPLICADO",
// };

// const chooseRandomItems = (arr, n) => {
//   const pool = [...arr];
//   const out = [];
//   while (pool.length && out.length < n) {
//     const idx = Math.floor(Math.random() * pool.length);
//     out.push(pool.splice(idx, 1)[0]);
//   }
//   return out;
// };

// const saveToRanking = (points) => {
//   const ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
//   ranking.push({ name: "Jogador", points });
//   localStorage.setItem("ranking", JSON.stringify(ranking));
// };

// // ========================== COMPONENTES AUXILIARES ==========================
// const DifficultySelector = ({ difficulty, setDifficulty }) => (
//   <div className="difficulty-selector">
//     {["facil", "medio", "dificil", "complicado"].map((level) => (
//       <button
//         key={level}
//         onClick={() => setDifficulty(level)}
//         className={`difficulty-btn ${difficulty === level ? "active" : ""}`}
//       >
//         {DIFFICULTY_LABEL[level]}
//       </button>
//     ))}
//   </div>
// );

// const Timer = ({ seconds, onTimeUp, isRunning, onTick }) => {
//   const [remaining, setRemaining] = useState(seconds);
//   const intervalRef = useRef(null);

//   useEffect(() => setRemaining(seconds), [seconds]);

//   useEffect(() => {
//     if (!isRunning) return;
//     intervalRef.current = setInterval(() => {
//       setRemaining((prev) => {
//         const next = prev - 1;
//         onTick?.(next);
//         if (next <= 0) {
//           clearInterval(intervalRef.current);
//           onTimeUp?.();
//           return 0;
//         }
//         return next;
//       });
//     }, 1000);
//     return () => clearInterval(intervalRef.current);
//   }, [isRunning]);

//   const pct = Math.max(0, Math.min(100, (remaining / seconds) * 100));
//   const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
//   const ss = String(remaining % 60).padStart(2, "0");

//   return (
//     <div className="timer">
//       <div className="timer-row">
//         <span className="time">⏱ {mm}:{ss}</span>
//         <span className="timer-total">/{String(Math.floor(seconds / 60)).padStart(2, "0")}:{String(seconds % 60).padStart(2, "0")}</span>
//       </div>
//       <div className="bar">
//         <div className="bar-fill" style={{ width: `${pct}%` }} />
//       </div>
//     </div>
//   );
// };

// const GameMenu = ({ setGame, setDifficulty, difficulty, score }) => (
//   <div className="game-menu">
//     <h2>🎮 Jogos Educativos</h2>
//     <p className="score">⭐ Pontos: <b>{score}</b></p>
//     <DifficultySelector setDifficulty={setDifficulty} difficulty={difficulty} />

//     <div className="menu-buttons">
//       <button onClick={() => setGame("anagram")} className="btn blue">🔤 Anagramas</button>
//       <button onClick={() => setGame("crossword")} className="btn green">🧩 Palavras Cruzadas</button>
//       <button onClick={() => setGame("crossmath")} className="btn red">➕ CrossMath</button>
//       <button onClick={() => setGame("ranking")} className="btn purple">🏆 Ranking</button>
//     </div>
//   </div>
// );

// // ========================== 1) ANAGRAMAS ==========================
// // Palavras por dificuldade
// const ANAGRAM_BANK = {
//   facil: ["casa", "pato", "bola", "rio", "mãe", "lua", "sol", "uva", "mesa", "bico"],
//   medio: ["escola", "amigos", "planta", "caderno", "lousa", "professor", "janela", "garrafa", "mochila"],
//   dificil: ["computador", "linguagem", "javascript", "biblioteca", "programador", "algoritmo", "sintaxe"],
//   complicado: ["infraestrutura", "desenvolvimento", "conectividade", "interoperavel", "responsividade", "confiabilidade", "compatibilidade", "otimizacao", "escalabilidade", "serializacao", "virtualizacao", "criptografia"],
// };

// const AnagramGame = ({ difficulty, onBack, addPoints }) => {
//   const targetList = useMemo(() => chooseRandomItems(ANAGRAM_BANK[difficulty], LEVEL_CONFIG[difficulty].items), [difficulty]);
//   const [index, setIndex] = useState(0);
//   const [input, setInput] = useState("");
//   const [message, setMessage] = useState("");
//   const [mistakes, setMistakes] = useState(0);
//   const [finished, setFinished] = useState(false);

//   const seconds = LEVEL_CONFIG[difficulty].seconds;
//   const current = targetList[index] || "";
//   const shuffled = useMemo(() => current.split("").sort(() => Math.random() - 0.5).join(""), [current]);

//   const onTimeUp = () => {
//     setFinished(true);
//     setMessage("⏰ Tempo esgotado! Jogo finalizado.");
//   };

//   const nextWord = () => {
//     if (index + 1 >= targetList.length) {
//       setFinished(true);
//       setMessage("🏁 Parabéns! Você concluiu este nível.");
//     } else {
//       setIndex(index + 1);
//       setInput("");
//       setMistakes(0);
//       setMessage("");
//     }
//   };

//   const checkAnswer = () => {
//     if (finished) return;
//     if (input.trim().toLowerCase() === current.toLowerCase()) {
//       setMessage("✅ Correto! +10 pontos");
//       addPoints(10);
//       saveToRanking(10);
//       nextWord();
//     } else {
//       setMistakes((m) => m + 1);
//       setMessage("❌ Tente novamente. Dica disponível!");
//     }
//   };

//   const hint = mistakes > 0 ? `Dica: começa com "${current[0]}" e termina com "${current[current.length - 1]}" (tem ${current.length} letras).` : null;

//   return (
//     <div className="game">
//       <h3>🔤 Anagramas — {DIFFICULTY_LABEL[difficulty]}</h3>

//       <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />

//       {!finished ? (
//         <>
//           <p>Reorganize as letras: <b className="scramble">{shuffled}</b></p>
//           <input
//             type="text"
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             className="input"
//             placeholder="Digite a palavra"
//             onKeyDown={(e) => e.key === "Enter" && checkAnswer()}
//           />
//           <button onClick={checkAnswer} className="btn blue">Verificar</button>
//           {hint && <p className="hint">💡 {hint}</p>}
//           <p className="progress">Palavra {index + 1} de {targetList.length}</p>
//         </>
//       ) : (
//         <>
//           <p>{message}</p>
//           <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//         </>
//       )}
//     </div>
//   );
// };

// // ========================== 2) PALAVRAS CRUZADAS (simples em sequência) ==========================
// // Banco de pistas (cada nível pede X palavras: 4, 6, 9, 12)
// const CROSSWORD_BANK = {
//   facil: [
//     { word: "sol", hint: "Brilha no céu" },
//     { word: "rio", hint: "Curso de água" },
//     { word: "mesa", hint: "Móvel para refeições" },
//     { word: "pão", hint: "Comida feita de farinha" },
//     { word: "lua", hint: "Satélite da Terra" },
//     { word: "flor", hint: "Parte colorida das plantas" },
//   ],
//   medio: [
//     { word: "caderno", hint: "Usado para escrever" },
//     { word: "professor", hint: "Quem ensina na escola" },
//     { word: "telefone", hint: "Aparelho para chamadas" },
//     { word: "janela", hint: "Abre para ventilar" },
//     { word: "mochila", hint: "Leva-se nas costas" },
//     { word: "lousa", hint: "Onde se escreve com giz" },
//     { word: "laranja", hint: "Fruta cítrica" },
//     { word: "mercado", hint: "Lugar de compras" },
//   ],
//   dificil: [
//     { word: "programador", hint: "Quem cria software" },
//     { word: "biblioteca", hint: "Lugar de livros" },
//     { word: "microscopio", hint: "Amplia objetos pequenos" },
//     { word: "triangulo", hint: "Figura de três lados" },
//     { word: "laboratorio", hint: "Local de experimentos" },
//     { word: "planilha", hint: "Documento de tabelas" },
//     { word: "geometria", hint: "Área da matemática" },
//     { word: "historia", hint: "Estudo do passado" },
//     { word: "gramatica", hint: "Regras da língua" },
//     { word: "algoritmo", hint: "Sequência de passos" },
//   ],
//   complicado: [
//     { word: "infraestrutura", hint: "Base de serviços e obras" },
//     { word: "conectividade", hint: "Capacidade de ligação" },
//     { word: "responsividade", hint: "Adaptação a diferentes telas" },
//     { word: "otimizacao", hint: "Tornar algo mais eficiente" },
//     { word: "escalabilidade", hint: "Crescer mantendo desempenho" },
//     { word: "confiabilidade", hint: "Qualidade de ser confiável" },
//     { word: "virtualizacao", hint: "Criar recurso virtual" },
//     { word: "compatibilidade", hint: "Capacidade de coexistir" },
//     { word: "serializacao", hint: "Transformar em série/bytes" },
//     { word: "criptografia", hint: "Proteção por códigos" },
//     { word: "interoperavel", hint: "Que funciona entre sistemas" },
//     { word: "documentacao", hint: "Conjunto de documentos" },
//     { word: "sustentavel", hint: "Que não agride o futuro" },
//   ],
// };

// const CrosswordWord = ({ target, onCorrect }) => {
//   const [letters, setLetters] = useState(Array(target.word.length).fill(""));
//   const [msg, setMsg] = useState("");

//   const check = () => {
//     if (letters.join("").toLowerCase() === target.word.toLowerCase()) {
//       setMsg("✅ Correto! +10 pontos");
//       onCorrect();
//     } else {
//       setMsg("❌ Ainda não está certo.");
//     }
//   };

//   return (
//     <div>
//       <p>Dica: {target.hint}</p>
//       <div className="crossword">
//         {letters.map((letter, i) => (
//           <input
//             key={i}
//             value={letter}
//             onChange={(e) => {
//               const val = e.target.value.slice(-1);
//               const newLetters = [...letters];
//               newLetters[i] = val.replace(/[^A-Za-zÀ-ÿ]/g, "");
//               setLetters(newLetters);
//             }}
//             maxLength={1}
//             className="crossword-cell"
//           />
//         ))}
//       </div>
//       <button onClick={check} className="btn green">Verificar</button>
//       <p>{msg}</p>
//     </div>
//   );
// };

// const CrosswordGame = ({ difficulty, onBack, addPoints }) => {
//   const pool = CROSSWORD_BANK[difficulty];
//   const needed = LEVEL_CONFIG[difficulty].items;
//   const targets = useMemo(() => chooseRandomItems(pool, Math.min(needed, pool.length)), [pool, needed]);

//   const [i, setI] = useState(0);
//   const [finished, setFinished] = useState(false);

//   const seconds = LEVEL_CONFIG[difficulty].seconds;
//   const onTimeUp = () => {
//     setFinished(true);
//   };

//   const handleCorrect = () => {
//     addPoints(10);
//     saveToRanking(10);
//     if (i + 1 >= targets.length) {
//       setFinished(true);
//     } else {
//       setI(i + 1);
//     }
//   };

//   return (
//     <div className="game">
//       <h3>🧩 Palavras Cruzadas — {DIFFICULTY_LABEL[difficulty]}</h3>
//       <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />

//       {!finished ? (
//         <>
//           <p className="progress">Palavra {i + 1} de {targets.length}</p>
//           <CrosswordWord target={targets[i]} onCorrect={handleCorrect} />
//         </>
//       ) : (
//         <>
//           <p>{i + 1 >= targets.length ? "🏁 Concluído!" : "⏰ Tempo esgotado!"}</p>
//           <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//         </>
//       )}
//     </div>
//   );
// };

// // ========================== 3) CROSSMATH ==========================
// const ops = ["+", "-", "×", "÷"]; // apresentação visual

// const generateProblem = () => {
//   const opIdx = Math.floor(Math.random() * 4);
//   const op = ops[opIdx];
//   let a = 0, b = 0, res = 0;
//   switch (op) {
//     case "+":
//       a = Math.floor(Math.random() * 30) + 1;
//       b = Math.floor(Math.random() * 30) + 1;
//       res = a + b;
//       break;
//     case "-":
//       a = Math.floor(Math.random() * 50) + 20;
//       b = Math.floor(Math.random() * 20) + 1;
//       res = a - b;
//       break;
//     case "×":
//       a = Math.floor(Math.random() * 12) + 2;
//       b = Math.floor(Math.random() * 12) + 2;
//       res = a * b;
//       break;
//     case "÷":
//       b = Math.floor(Math.random() * 12) + 2;
//       res = Math.floor(Math.random() * 12) + 2;
//       a = b * res; // garante divisão exata
//       break;
//     default:
//       break;
//   }
//   return { a, b, op, result: res };
// };

// const buildProblems = (n) => Array.from({ length: n }, generateProblem);

// const CrossMathGame = ({ difficulty, onBack, addPoints }) => {
//   const total = LEVEL_CONFIG[difficulty].items;
//   const [problems] = useState(() => buildProblems(total));
//   const [i, setI] = useState(0);
//   const [input, setInput] = useState("");
//   const [finished, setFinished] = useState(false);
//   const [msg, setMsg] = useState("");

//   const seconds = LEVEL_CONFIG[difficulty].seconds;
//   const onTimeUp = () => setFinished(true);

//   const check = () => {
//     if (finished) return;
//     const correct = Number(input) === problems[i].result;
//     if (correct) {
//       addPoints(10);
//       saveToRanking(10);
//       setMsg("✅ Correto! +10 pontos");
//       if (i + 1 >= problems.length) {
//         setFinished(true);
//       } else {
//         setI(i + 1);
//         setInput("");
//       }
//     } else {
//       setMsg("❌ Errado, tente novamente.");
//     }
//   };

//   return (
//     <div className="game">
//       <h3>➕ CrossMath — {DIFFICULTY_LABEL[difficulty]}</h3>
//       <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />

//       {!finished ? (
//         <>
//           <p className="progress">Questão {i + 1} de {problems.length}</p>
//           <p>Resolva: {problems[i].a} {problems[i].op} {problems[i].b} = ?</p>
//           <input
//             type="number"
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             className="input"
//             placeholder="Sua resposta"
//             onKeyDown={(e) => e.key === "Enter" && check()}
//           />
//           <button onClick={check} className="btn red">Verificar</button>
//           <p>{msg}</p>
//         </>
//       ) : (
//         <>
//           <p>{i + 1 >= problems.length ? "🏁 Concluído!" : "⏰ Tempo esgotado!"}</p>
//           <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//         </>
//       )}
//     </div>
//   );
// };

// // ========================== 4) RANKING ==========================
// const Ranking = ({ onBack }) => {
//   const [ranking, setRanking] = useState([]);

//   useEffect(() => {
//     const data = JSON.parse(localStorage.getItem("ranking") || "[]");
//     const scores = {};
//     data.forEach((r) => {
//       scores[r.name] = (scores[r.name] || 0) + r.points;
//     });
//     const sorted = Object.entries(scores)
//       .map(([name, points]) => ({ name, points }))
//       .sort((a, b) => b.points - a.points)
//       .slice(0, 10);
//     setRanking(sorted);
//   }, []);

//   return (
//     <div className="game">
//       <h3>🏆 Ranking</h3>
//       <ol>
//         {ranking.map((r, i) => (
//           <li key={i}><b>{i + 1}. {r.name}</b> — {r.points} pts</li>
//         ))}
//       </ol>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // ========================== PÁGINA PRINCIPAL ==========================
// const Jogos = () => {
//   const [game, setGame] = useState(null); // anagram | crossword | crossmath | ranking
//   const [difficulty, setDifficulty] = useState("facil");
//   const [score, setScore] = useState(0);

//   useEffect(() => {
//     const saved = localStorage.getItem("score");
//     if (saved) setScore(parseInt(saved));
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("score", score);
//   }, [score]);

//   const addPoints = (points) => setScore((prev) => prev + points);

//   return (
//     <div>
//       <Header />
//       <section className="jogos-section">
//         <div className="container">
//           {game === "anagram" && (
//             <AnagramGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "crossword" && (
//             <CrosswordGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "crossmath" && (
//             <CrossMathGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "ranking" && <Ranking onBack={() => setGame(null)} />}
//           {!game && (
//             <GameMenu
//               setGame={setGame}
//               setDifficulty={setDifficulty}
//               difficulty={difficulty}
//               score={score}
//             />
//           )}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default Jogos;

// LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL
// /* ========================= Jogos.css ========================= */
// /* Coloque em src/Jogos.css */

// .jogos-section {
//   padding: 120px 20px 60px;
//   background: #f3f4f6;
//   min-height: 100vh;
//   text-align: center;
// }

// .container { max-width: 900px; margin: 0 auto; }

// .game-menu h2 {
//   font-size: 28px;
//   color: #1E3A8A;
//   margin-bottom: 10px;
// }

// .score { margin-bottom: 20px; font-size: 18px; }

// .difficulty-selector {
//   display: flex;
//   justify-content: center;
//   gap: 10px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// }

// .difficulty-btn {
//   padding: 8px 16px;
//   border: 1px solid #ccc;
//   border-radius: 6px;
//   background: #eee;
//   cursor: pointer;
// }

// .difficulty-btn.active { background: #1E3A8A; color: #fff; }

// .menu-buttons { display: flex; flex-direction: column; gap: 10px; }

// .btn {
//   padding: 10px;
//   border: none;
//   border-radius: 6px;
//   color: #fff;
//   font-weight: bold;
//   cursor: pointer;
// }

// .btn.blue { background: #3B82F6; }
// .btn.green { background: #10B981; }
// .btn.red { background: #EF4444; }
// .btn.purple { background: #8B5CF6; }
// .btn.gray { background: #9CA3AF; }

// .back-btn {
//   margin-top: 15px;
//   background: #D1D5DB;
//   border: none;
//   padding: 6px 14px;
//   border-radius: 6px;
//   cursor: pointer;
// }

// .game h3 { font-size: 22px; margin-bottom: 10px; }

// .input {
//   padding: 8px;
//   margin: 10px;
//   border: 1px solid #ccc;
//   border-radius: 6px;
// }

// .crossword {
//   display: flex;
//   gap: 6px;
//   justify-content: center;
//   margin: 20px 0;
//   flex-wrap: wrap;
// }

// .crossword-cell {
//   width: 40px;
//   height: 40px;
//   text-align: center;
//   font-size: 18px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
// }

// .timer { margin: 10px 0 16px; }
// .timer-row { display: flex; align-items: baseline; justify-content: center; gap: 6px; margin-bottom: 6px; }
// .time { font-weight: 700; }
// .timer-total { color: #6b7280; font-size: 12px; }
// .bar { height: 8px; background: #e5e7eb; border-radius: 6px; overflow: hidden; max-width: 420px; margin: 0 auto; }
// .bar-fill { height: 100%; background: #10B981; }

// .progress { color: #374151; margin-top: 8px; }
// .scramble { letter-spacing: 2px; }
// .hint { color: #6b7280; margin-top: 8px; }

// ========================= Jogos.jsx =========================
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import "./Jogos.css";
// import Header from "./Header";
// import Footer from "./Footer";
// import CrosswordGame from "./CrosswordGame";

// // ========================== CONFIGURAÇÕES GERAIS ==========================
// const LEVEL_CONFIG = {
//   facil: { items: 4, seconds: 60 },
//   medio: { items: 6, seconds: 120 },
//   dificil: { items: 9, seconds: 300 },
//   complicado: { items: 12, seconds: 420 },
// };

// const DIFFICULTY_LABEL = {
//   facil: "FÁCIL",
//   medio: "MÉDIO",
//   dificil: "DIFÍCIL",
//   complicado: "COMPLICADO",
// };

// const chooseRandomItems = (arr, n) => {
//   const pool = [...arr];
//   const out = [];
//   while (pool.length && out.length < n) {
//     const idx = Math.floor(Math.random() * pool.length);
//     out.push(pool.splice(idx, 1)[0]);
//   }
//   return out;
// };

// const saveToRanking = (points) => {
//   const ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
//   ranking.push({ name: "Jogador", points });
//   localStorage.setItem("ranking", JSON.stringify(ranking));
// };

// // ========================== COMPONENTES AUXILIARES ==========================
// const DifficultySelector = ({ difficulty, setDifficulty }) => (
//   <div className="difficulty-selector">
//     {["facil", "medio", "dificil", "complicado"].map((level) => (
//       <button
//         key={level}
//         onClick={() => setDifficulty(level)}
//         className={`difficulty-btn ${difficulty === level ? "active" : ""}`}
//       >
//         {DIFFICULTY_LABEL[level]}
//       </button>
//     ))}
//   </div>
// );

// const Timer = ({ seconds, onTimeUp, isRunning, onTick }) => {
//   const [remaining, setRemaining] = useState(seconds);
//   const intervalRef = useRef(null);

//   useEffect(() => setRemaining(seconds), [seconds]);

//   useEffect(() => {
//     if (!isRunning) return;
//     intervalRef.current = setInterval(() => {
//       setRemaining((prev) => {
//         const next = prev - 1;
//         onTick?.(next);
//         if (next <= 0) {
//           clearInterval(intervalRef.current);
//           onTimeUp?.();
//           return 0;
//         }
//         return next;
//       });
//     }, 1000);
//     return () => clearInterval(intervalRef.current);
//   }, [isRunning]);

//   const pct = Math.max(0, Math.min(100, (remaining / seconds) * 100));
//   const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
//   const ss = String(remaining % 60).padStart(2, "0");

//   return (
//     <div className="timer">
//       <div className="timer-row">
//         <span className="time">⏱ {mm}:{ss}</span>
//         <span className="timer-total">
//           /{String(Math.floor(seconds / 60)).padStart(2, "0")}:
//           {String(seconds % 60).padStart(2, "0")}
//         </span>
//       </div>
//       <div className="bar">
//         <div className="bar-fill" style={{ width: `${pct}%` }} />
//       </div>
//     </div>
//   );
// };

// const GameMenu = ({ setGame, setDifficulty, difficulty, score }) => (
//   <div className="game-menu">
//     <h2>🎮 Jogos Educativos</h2>
//     <p className="score">
//       ⭐ Pontos: <b>{score}</b>
//     </p>
//     <DifficultySelector setDifficulty={setDifficulty} difficulty={difficulty} />

//     <div className="menu-buttons">
//       <button onClick={() => setGame("anagram")} className="btn blue">🔤 Anagramas</button>
//       <button onClick={() => setGame("crossword")} className="btn green">🧩 Palavras Cruzadas</button>
//       <button onClick={() => setGame("crossmath")} className="btn red">➕ CrossMath</button>
//       <button onClick={() => setGame("ranking")} className="btn purple">🏆 Ranking</button>
//     </div>
//   </div>
// );

// // ========================== 1) ANAGRAMAS ==========================
// const ANAGRAM_BANK = {
//   facil: ["casa", "pato", "bola", "rio", "mãe", "lua", "sol", "uva", "mesa", "bico"],
//   medio: ["escola", "amigos", "planta", "caderno", "lousa", "professor", "janela", "garrafa", "mochila"],
//   dificil: ["computador", "linguagem", "javascript", "biblioteca", "programador", "algoritmo", "sintaxe"],
//   complicado: ["infraestrutura", "desenvolvimento", "conectividade", "interoperavel", "responsividade", "confiabilidade", "compatibilidade", "otimizacao", "escalabilidade", "serializacao", "virtualizacao", "criptografia"],
// };

// const AnagramGame = ({ difficulty, onBack, addPoints }) => {
//   const targetList = useMemo(() => chooseRandomItems(ANAGRAM_BANK[difficulty], LEVEL_CONFIG[difficulty].items), [difficulty]);
//   const [index, setIndex] = useState(0);
//   const [input, setInput] = useState("");
//   const [message, setMessage] = useState("");
//   const [mistakes, setMistakes] = useState(0);
//   const [finished, setFinished] = useState(false);

//   const seconds = LEVEL_CONFIG[difficulty].seconds;
//   const current = targetList[index] || "";
//   const shuffled = useMemo(() => current.split("").sort(() => Math.random() - 0.5).join(""), [current]);

//   const onTimeUp = () => {
//     setFinished(true);
//     setMessage("⏰ Tempo esgotado! Jogo finalizado.");
//   };

//   const nextWord = () => {
//     if (index + 1 >= targetList.length) {
//       setFinished(true);
//       setMessage("🏁 Parabéns! Você concluiu este nível.");
//     } else {
//       setIndex(index + 1);
//       setInput("");
//       setMistakes(0);
//       setMessage("");
//     }
//   };

//   const checkAnswer = () => {
//     if (finished) return;
//     if (input.trim().toLowerCase() === current.toLowerCase()) {
//       setMessage("✅ Correto! +10 pontos");
//       addPoints(10);
//       saveToRanking(10);
//       nextWord();
//     } else {
//       setMistakes((m) => m + 1);
//       setMessage("❌ Tente novamente. Dica disponível!");
//     }
//   };

//   const hint = mistakes > 0 ? `Dica: começa com "${current[0]}" e termina com "${current[current.length - 1]}" (tem ${current.length} letras).` : null;

//   return (
//     <div className="game">
//       <h3>🔤 Anagramas — {DIFFICULTY_LABEL[difficulty]}</h3>
//       <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />
//       {!finished ? (
//         <>
//           <p>Reorganize as letras: <b className="scramble">{shuffled}</b></p>
//           <input
//             type="text"
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             className="input"
//             placeholder="Digite a palavra"
//             onKeyDown={(e) => e.key === "Enter" && checkAnswer()}
//           />
//           <button onClick={checkAnswer} className="btn blue">Verificar</button>
//           {hint && <p className="hint">💡 {hint}</p>}
//           <p className="progress">Palavra {index + 1} de {targetList.length}</p>
//         </>
//       ) : (
//         <>
//           <p>{message}</p>
//           <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//         </>
//       )}
//     </div>
//   );
// };

// // ========================== 2) PALAVRAS CRUZADAS DINÂMICA ==========================
// const CrosswordGameWrapper = ({ difficulty, onBack, addPoints }) => {
//   const WORDS_BANK = {
//     facil: [
//       { word: "RELAXADO", clue: "Contrário de tenso" },
//       { word: "ESTATUA", clue: "Escultura em pedra ou bronze" },
//       { word: "OUVIR", clue: "Ação feita com os ouvidos" },
//       { word: "VIAGEM", clue: "Deslocamento para outro lugar" },
//       { word: "FLORESTA", clue: "Conjunto grande de árvores" },
//       { word: "CIENCIA", clue: "Estudo baseado em experimentos" },
//     ],
//     medio: [
//       { word: "CADERNO", clue: "Usado para escrever" },
//       { word: "PROFESSOR", clue: "Quem ensina na escola" },
//       { word: "TELEFONE", clue: "Aparelho para chamadas" },
//       { word: "JANELA", clue: "Abre para ventilar" },
//       { word: "MOCHILA", clue: "Leva-se nas costas" },
//       { word: "LOUSA", clue: "Onde se escreve com giz" },
//       { word: "LARANJA", clue: "Fruta cítrica" },
//       { word: "MERCADO", clue: "Lugar de compras" },
//     ],
//     dificil: [
//       { word: "PROGRAMADOR", clue: "Quem cria software" },
//       { word: "BIBLIOTECA", clue: "Lugar de livros" },
//       { word: "MICROSCOPIO", clue: "Amplia objetos pequenos" },
//       { word: "TRIANGULO", clue: "Figura de três lados" },
//       { word: "LABORATORIO", clue: "Local de experimentos" },
//       { word: "PLANILHA", clue: "Documento de tabelas" },
//       { word: "GEOMETRIA", clue: "Área da matemática" },
//       { word: "HISTORIA", clue: "Estudo do passado" },
//       { word: "GRAMATICA", clue: "Regras da língua" },
//       { word: "ALGORITMO", clue: "Sequência de passos" },
//     ],
//     complicado: [
//       { word: "INFRAESTRUTURA", clue: "Base de serviços e obras" },
//       { word: "CONECTIVIDADE", clue: "Capacidade de ligação" },
//       { word: "RESPONSIVIDADE", clue: "Adaptação a diferentes telas" },
//       { word: "OTIMIZACAO", clue: "Tornar algo mais eficiente" },
//       { word: "ESCALABILIDADE", clue: "Crescer mantendo desempenho" },
//       { word: "CONFIABILIDADE", clue: "Qualidade de ser confiável" },
//       { word: "VIRTUALIZACAO", clue: "Criar recurso virtual" },
//       { word: "COMPATIBILIDADE", clue: "Capacidade de coexistir" },
//       { word: "SERIALIZACAO", clue: "Transformar em série/bytes" },
//       { word: "CRIPTOGRAFIA", clue: "Proteção por códigos" },
//       { word: "INTEROPERAVEL", clue: "Que funciona entre sistemas" },
//       { word: "DOCUMENTACAO", clue: "Conjunto de documentos" },
//       { word: "SUSTENTAVEL", clue: "Que não agride o futuro" },
//     ],
//   };

//   const words = WORDS_BANK[difficulty] || WORDS_BANK.facil;

//   return (
//     <div className="game">
//       <h3>🧩 Palavras Cruzadas — {DIFFICULTY_LABEL[difficulty]}</h3>
//       <CrosswordGame words={words} />
//       <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//     </div>
//   );
// };

// // ========================== 3) CROSSMATH ==========================
// const ops = ["+", "-", "×", "÷"];

// const generateProblem = () => {
//   const opIdx = Math.floor(Math.random() * 4);
//   const op = ops[opIdx];
//   let a = 0, b = 0, res = 0;
//   switch (op) {
//     case "+": a = Math.floor(Math.random() * 30) + 1; b = Math.floor(Math.random() * 30) + 1; res = a + b; break;
//     case "-": a = Math.floor(Math.random() * 50) + 20; b = Math.floor(Math.random() * 20) + 1; res = a - b; break;
//     case "×": a = Math.floor(Math.random() * 12) + 2; b = Math.floor(Math.random() * 12) + 2; res = a * b; break;
//     case "÷": b = Math.floor(Math.random() * 12) + 2; res = Math.floor(Math.random() * 12) + 2; a = b * res; break;
//     default: break;
//   }
//   return { a, b, op, result: res };
// };

// const buildProblems = (n) => Array.from({ length: n }, generateProblem);

// const CrossMathGame = ({ difficulty, onBack, addPoints }) => {
//   const total = LEVEL_CONFIG[difficulty].items;
//   const [problems] = useState(() => buildProblems(total));
//   const [i, setI] = useState(0);
//   const [input, setInput] = useState("");
//   const [finished, setFinished] = useState(false);
//   const [msg, setMsg] = useState("");

//   const seconds = LEVEL_CONFIG[difficulty].seconds;
//   const onTimeUp = () => setFinished(true);

//   const check = () => {
//     if (finished) return;
//     const correct = Number(input) === problems[i].result;
//     if (correct) {
//       addPoints(10);
//       saveToRanking(10);
//       setMsg("✅ Correto! +10 pontos");
//       if (i + 1 >= problems.length) setFinished(true);
//       else { setI(i + 1); setInput(""); }
//     } else setMsg("❌ Errado, tente novamente.");
//   };

//   return (
//     <div className="game">
//       <h3>➕ CrossMath — {DIFFICULTY_LABEL[difficulty]}</h3>
//       <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />
//       {!finished ? (
//         <>
//           <p className="progress">Questão {i + 1} de {problems.length}</p>
//           <p>Resolva: {problems[i].a} {problems[i].op} {problems[i].b} = ?</p>
//           <input
//             type="number"
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             className="input"
//             placeholder="Sua resposta"
//             onKeyDown={(e) => e.key === "Enter" && check()}
//           />
//           <button onClick={check} className="btn red">Verificar</button>
//           <p>{msg}</p>
//         </>
//       ) : (
//         <>
//           <p>{i + 1 >= problems.length ? "🏁 Concluído!" : "⏰ Tempo esgotado!"}</p>
//           <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
//         </>
//       )}
//     </div>
//   );
// };

// // ========================== 4) RANKING ==========================
// const Ranking = ({ onBack }) => {
//   const [ranking, setRanking] = useState([]);

//   useEffect(() => {
//     const data = JSON.parse(localStorage.getItem("ranking") || "[]");
//     const scores = {};
//     data.forEach((r) => { scores[r.name] = (scores[r.name] || 0) + r.points; });
//     const sorted = Object.entries(scores)
//       .map(([name, points]) => ({ name, points }))
//       .sort((a, b) => b.points - a.points)
//       .slice(0, 10);
//     setRanking(sorted);
//   }, []);

//   return (
//     <div className="game">
//       <h3>🏆 Ranking</h3>
//       <ol>
//         {ranking.map((r, i) => (
//           <li key={i}><b>{i + 1}. {r.name}</b> — {r.points} pts</li>
//         ))}
//       </ol>
//       <button onClick={onBack} className="back-btn">⬅ Voltar</button>
//     </div>
//   );
// };

// // ========================== PÁGINA PRINCIPAL ==========================
// const Jogos = () => {
//   const [game, setGame] = useState(null);
//   const [difficulty, setDifficulty] = useState("facil");
//   const [score, setScore] = useState(0);

//   useEffect(() => {
//     const saved = localStorage.getItem("score");
//     if (saved) setScore(parseInt(saved));
//   }, []);

//   useEffect(() => { localStorage.setItem("score", score); }, [score]);

//   const addPoints = (points) => setScore((prev) => prev + points);

//   return (
//     <div>
//       <Header />
//       <section className="jogos-section">
//         <div className="container">
//           {game === "anagram" && (
//             <AnagramGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "crossword" && (
//             <CrosswordGameWrapper difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "crossmath" && (
//             <CrossMathGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
//           )}
//           {game === "ranking" && <Ranking onBack={() => setGame(null)} />}
//           {!game && (
//             <GameMenu
//               setGame={setGame}
//               setDifficulty={setDifficulty}
//               difficulty={difficulty}
//               score={score}
//             />
//           )}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default Jogos;

//hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh

import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Jogos.css";
import Header from "./Header";
import Footer from "./Footer";
import CrosswordGame from "./CrosswordGame";

// ========================== CONFIGURAÇÕES GERAIS ==========================
const LEVEL_CONFIG = {
  facil: { items: 4, seconds: 60 },
  medio: { items: 6, seconds: 120 },
  dificil: { items: 9, seconds: 300 },
  complicado: { items: 12, seconds: 420 },
};

const DIFFICULTY_LABEL = {
  facil: "FÁCIL",
  medio: "MÉDIO",
  dificil: "DIFÍCIL",
  complicado: "COMPLICADO",
};

const chooseRandomItems = (arr, n) => {
  const pool = [...arr];
  const out = [];
  while (pool.length && out.length < n) {
    const idx = Math.floor(Math.random() * pool.length);
    out.push(pool.splice(idx, 1)[0]);
  }
  return out;
};

const saveToRanking = (points) => {
  const ranking = JSON.parse(localStorage.getItem("ranking") || "[]");
  ranking.push({ name: "Jogador", points });
  localStorage.setItem("ranking", JSON.stringify(ranking));
};

// ========================== COMPONENTES AUXILIARES ==========================
const DifficultySelector = ({ difficulty, setDifficulty }) => (
  <div className="difficulty-selector">
    {["facil", "medio", "dificil", "complicado"].map((level) => (
      <button
        key={level}
        onClick={() => setDifficulty(level)}
        className={`difficulty-btn ${difficulty === level ? "active" : ""}`}
      >
        {DIFFICULTY_LABEL[level]}
      </button>
    ))}
  </div>
);

const Timer = ({ seconds, onTimeUp, isRunning, onTick }) => {
  const [remaining, setRemaining] = useState(seconds);
  const intervalRef = useRef(null);

  useEffect(() => setRemaining(seconds), [seconds]);

  useEffect(() => {
    if (!isRunning) return;
    intervalRef.current = setInterval(() => {
      setRemaining((prev) => {
        const next = prev - 1;
        onTick?.(next);
        if (next <= 0) {
          clearInterval(intervalRef.current);
          onTimeUp?.();
          return 0;
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [isRunning, onTimeUp, onTick]);

  const pct = Math.max(0, Math.min(100, (remaining / seconds) * 100));
  const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
  const ss = String(remaining % 60).padStart(2, "0");

  return (
    <div className="timer">
      <div className="timer-row">
        <span className="time">⏱ {mm}:{ss}</span>
        <span className="timer-total">
          /{String(Math.floor(seconds / 60)).padStart(2, "0")}:
          {String(seconds % 60).padStart(2, "0")}
        </span>
      </div>
      <div className="bar">
        <div className="bar-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

const GameMenu = ({ setGame, setDifficulty, difficulty, score }) => (
  <div className="game-menu">
    <h2>🎮 Jogos Educativos</h2>
    <p className="score">
      ⭐ Pontos: <b>{score}</b>
    </p>
    <DifficultySelector setDifficulty={setDifficulty} difficulty={difficulty} />

    <div className="menu-buttons">
      <button onClick={() => setGame("anagram")} className="btn blue">🔤 Anagramas</button>
      <button onClick={() => setGame("crossword")} className="btn green">🧩 Palavras Cruzadas</button>
      <button onClick={() => setGame("crossmath")} className="btn red">➕ CrossMath</button>
      <button onClick={() => setGame("ranking")} className="btn purple">🏆 Ranking</button>
    </div>
  </div>
);

// ========================== 1) ANAGRAMAS ==========================
const ANAGRAM_BANK = {
  facil: ["casa", "pato", "bola", "rio", "mãe", "lua", "sol", "uva", "mesa", "bico"],
  medio: ["escola", "amigos", "planta", "caderno", "lousa", "professor", "janela", "garrafa", "mochila"],
  dificil: ["computador", "linguagem", "javascript", "biblioteca", "programador", "algoritmo", "sintaxe"],
  complicado: ["infraestrutura", "desenvolvimento", "conectividade", "interoperavel", "responsividade", "confiabilidade", "compatibilidade", "otimizacao", "escalabilidade", "serializacao", "virtualizacao", "criptografia"],
};

const AnagramGame = ({ difficulty, onBack, addPoints }) => {
  const targetList = useMemo(() => chooseRandomItems(ANAGRAM_BANK[difficulty], LEVEL_CONFIG[difficulty].items), [difficulty]);
  const [index, setIndex] = useState(0);
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [mistakes, setMistakes] = useState(0);
  const [finished, setFinished] = useState(false);

  const seconds = LEVEL_CONFIG[difficulty].seconds;
  const current = targetList[index] || "";
  const shuffled = useMemo(() => current.split("").sort(() => Math.random() - 0.5).join(""), [current]);

  const onTimeUp = () => {
    setFinished(true);
    setMessage("⏰ Tempo esgotado! Jogo finalizado.");
  };

  const nextWord = () => {
    if (index + 1 >= targetList.length) {
      setFinished(true);
      setMessage("🏁 Parabéns! Você concluiu este nível.");
    } else {
      setIndex(index + 1);
      setInput("");
      setMistakes(0);
      setMessage("");
    }
  };

  const checkAnswer = () => {
    if (finished) return;
    if (input.trim().toLowerCase() === current.toLowerCase()) {
      setMessage("✅ Correto! +10 pontos");
      addPoints(10);
      saveToRanking(10);
      nextWord();
    } else {
      setMistakes((m) => m + 1);
      setMessage("❌ Tente novamente. Dica disponível!");
    }
  };

  const hint = mistakes > 0 ? `Dica: começa com "${current[0]}" e termina com "${current[current.length - 1]}" (tem ${current.length} letras).` : null;

  return (
    <div className="game">
      <h3>🔤 Anagramas — {DIFFICULTY_LABEL[difficulty]}</h3>
      <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />
      {!finished ? (
        <>
          <p>Reorganize as letras: <b className="scramble">{shuffled}</b></p>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="input"
            placeholder="Digite a palavra"
            onKeyDown={(e) => e.key === "Enter" && checkAnswer()}
          />
          <button onClick={checkAnswer} className="btn blue">Verificar</button>
          {hint && <p className="hint">💡 {hint}</p>}
          <p className="progress">Palavra {index + 1} de {targetList.length}</p>
        </>
      ) : (
        <>
          <p>{message}</p>
          <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
        </>
      )}
    </div>
  );
};

// ========================== 2) PALAVRAS CRUZADAS DINÂMICA ==========================
const CrosswordGameWrapper = ({ difficulty, onBack, addPoints }) => {
  const WORDS_BANK = {
  facil: [
    { word: "SAMORA", clue: "Primeiro presidente de Moçambique." },
    { word: "MAPUTO", clue: "Capital de Moçambique." },
    { word: "FRELIMO", clue: "Partido que liderou a luta pela independência." },
    { word: "RENAMO", clue: "Partido político rival da FRELIMO." },
    { word: "MOCAMBIQUE", clue: "Nome oficial do país." },
    { word: "MATOLA", clue: "Município nos arredores de Maputo, importante na história." },
  ],
  medio: [
    { word: "INDEPENDENCIA", clue: "O termo da conquista da liberdade em 1975." },
    { word: "COMBATENTE", clue: "Um participante da luta pela independência de Moçambique." },
    { word: "CHISSANO", clue: "Ex-presidente de Moçambique, líder após a guerra civil." },
    { word: "ZAMBEZE", clue: "Maior rio de Moçambique." },
    { word: "CHIPANDE", clue: "Lider militar da FRELIMO. Conhecido por dar o primeiro tiro." },
    { word: "HISTORIOGRAFIA", clue: "Estudo das histórias de Moçambique e seus heróis." },
    { word: "NGUNGUNHANE", clue: "Último Rei de Gaza." },
    { word: "PAZ", clue: "Estado de tranquilidade alcançado após uma guerra." },
  ],
  dificil: [
    { word: "SAMORA", clue: "Primeiro presidente de Moçambique após a independência" },
    { word: "MALANGATANA", clue: "Grande artista plástico de obras contenporâneas." },
    { word: "AZAGAIA", clue: "Grande Rapper de intervenção social." },
    { word: "CRAVEIRINHA", clue: "Apelido de um poeta moçambicano, ativo na luta social pela liberdade." },
    { word: "RENAMO", clue: "Partido de oposição na história recente de Moçambique." },
    { word: "CHISSANO", clue: "Ex-presidente de Moçambique e diplomata importante." },
    { word: "GRACA", clue: "Primeira Primeira-dama de Mocambique." },
    { word: "DHLAKAMA", clue: "Fundador e Líder de um grupo de guerrilha que se opós ao Governo." },
    { word: "SADC", clue: "Aliança de países sul-africanos formada após a independência." },
    { word: "CHISSANO", clue: "Presidente após a guerra civil, participou no processo de reconciliação." },
    { word: "ACORDO", clue: "Pacto formal de paz assinado entre FRELIMO e RENAMO." },
    { word: "BANTU", clue: "Conjunto de línguas Níger-Congo faladas no centro e sul de África." },
    { word: "UDENAMO", clue: "Um dos três partidos politicos que formou a FRELIMO." },
  ],
  complicado: [
    { word: "RECONCILIAÇÃO", clue: "Processo de pacificação entre FRELIMO e RENAMO após a guerra civil." },
    { word: "ACORDO", clue: "Pacto formal de paz assinado entre FRELIMO e RENAMO." },
    { word: "PIDE", clue: "Ex-grupo governamental responsável pela repressão de todas as formas de oposição ao regime colonial Português." },
    { word: "FRELIMO", clue: "Partido que liderou a luta pela independência e governo após 1975." },
    { word: "RENAMO", clue: "Partido de oposição que protagonizou a guerra civil." },
    { word: "HISTORIA", clue: "Estudo do passado e eventos que marcaram Moçambique." },
    { word: "SOFALA", clue: "Província no centro de Moçambique." },
    { word: "UDENAMO", clue: "Nome de um partido importante na formação da resistência nacional" },
    { word: "BIBLIOTECA", clue: "Local onde se preserva a história escrita de Moçambique." },
    { word: "ROMA", clue: "Local onde foram assinados os acordos de paz para o termino da guerra dos 16 anos." },
    { word: "LUSAKA", clue: "Local onde foram assinados os acordos de paz para o término da guerra pela independência." },
    { word: "DHLAKAMA", clue: "Fundador e líder de um grupo de guerrilha que se opós ao governo." },
  ],
};

  // const WORDS_BANK = {
  //   facil: [
  //     { word: "RELAXADO", clue: "Contrário de tenso" },
  //     { word: "ESTATUA", clue: "Escultura em pedra ou bronze" },
  //     { word: "OUVIR", clue: "Ação feita com os ouvidos" },
  //     { word: "VIAGEM", clue: "Deslocamento para outro lugar" },
  //     { word: "FLORESTA", clue: "Conjunto grande de árvores" },
  //     { word: "CIENCIA", clue: "Estudo baseado em experimentos" },
  //   ],
  //   medio: [
  //     { word: "CADERNO", clue: "Usado para escrever" },
  //     { word: "PROFESSOR", clue: "Quem ensina na escola" },
  //     { word: "TELEFONE", clue: "Aparelho para chamadas" },
  //     { word: "JANELA", clue: "Abre para ventilar" },
  //     { word: "MOCHILA", clue: "Leva-se nas costas" },
  //     { word: "LOUSA", clue: "Onde se escreve com giz" },
  //     { word: "LARANJA", clue: "Fruta cítrica" },
  //     { word: "MERCADO", clue: "Lugar de compras" },
  //   ],
  //   dificil: [
  //     { word: "PROGRAMADOR", clue: "Quem cria software" },
  //     { word: "BIBLIOTECA", clue: "Lugar de livros" },
  //     { word: "MICROSCOPIO", clue: "Amplia objetos pequenos" },
  //     { word: "TRIANGULO", clue: "Figura de três lados" },
  //     { word: "LABORATORIO", clue: "Local de experimentos" },
  //     { word: "PLANILHA", clue: "Documento de tabelas" },
  //     { word: "GEOMETRIA", clue: "Área da matemática" },
  //     { word: "HISTORIA", clue: "Estudo do passado" },
  //     { word: "GRAMATICA", clue: "Regras da língua" },
  //     { word: "ALGORITMO", clue: "Sequência de passos" },
  //   ],
  //   complicado: [
  //     { word: "INFRAESTRUTURA", clue: "Base de serviços e obras" },
  //     { word: "CONECTIVIDADE", clue: "Capacidade de ligação" },
  //     { word: "RESPONSIVIDADE", clue: "Adaptação a diferentes telas" },
  //     { word: "OTIMIZACAO", clue: "Tornar algo mais eficiente" },
  //     { word: "ESCALABILIDADE", clue: "Crescer mantendo desempenho" },
  //     { word: "CONFIABILIDADE", clue: "Qualidade de ser confiável" },
  //     { word: "VIRTUALIZACAO", clue: "Criar recurso virtual" },
  //     { word: "COMPATIBILIDADE", clue: "Capacidade de coexistir" },
  //     { word: "SERIALIZACAO", clue: "Transformar em série/bytes" },
  //     { word: "CRIPTOGRAFIA", clue: "Proteção por códigos" },
  //     { word: "INTEROPERAVEL", clue: "Que funciona entre sistemas" },
  //     { word: "DOCUMENTACAO", clue: "Conjunto de documentos" },
  //     { word: "SUSTENTAVEL", clue: "Que não agride o futuro" },
  //   ],
  // };

  const wordsRaw = WORDS_BANK[difficulty] || WORDS_BANK.facil;
  const words = wordsRaw.map((w, index) => ({ ...w, index }));

  return (
    <div className="game">
      <h3>🧩 Palavras Cruzadas — {DIFFICULTY_LABEL[difficulty]}</h3>
      <CrosswordGame words={words} />
      <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
    </div>
  );
};

// ========================== 3) CROSSMATH ==========================
const apply = (a, op, b) => {
  a = Number(a);
  b = Number(b);
  if (isNaN(a) || isNaN(b)) return NaN;
  if (op === '+') return a + b;
  if (op === '-') return a - b;
  if (op === '×') return a * b;
  if (op === '÷') {
    if (b === 0 || a % b !== 0) return NaN;
    return a / b;
  }
  return NaN;
};

const generatePuzzle = (difficulty) => {
  const opMap = {
    facil: ["+", "-"],
    medio: ["+", "-", "×"],
    dificil: ["+", "-", "×", "÷"],
    complicado: ["+", "-", "×", "÷"]
  };
  const opPool = opMap[difficulty] || opMap.facil;

  let attempts = 0;
  while (attempts < 10000) {
    attempts++;
    const allOps = Array(12).fill().map(() => opPool[Math.floor(Math.random() * opPool.length)]);
    const horiz_ops = [
      allOps.slice(0,2),
      allOps.slice(2,4),
      allOps.slice(4,6)
    ];
    const vert_ops = [
      allOps.slice(6,9),
      allOps.slice(9,12)
    ];

    const numsFlat = Array.from({length: 9}, (_, i) => i + 1).sort(() => Math.random() - 0.5);
    const numbers = [
      numsFlat.slice(0,3),
      numsFlat.slice(3,6),
      numsFlat.slice(6,9)
    ];

    let valid = true;
    const targets_h = [];
    for (let i = 0; i < 3; i++) {
      let v = numbers[i][0];
      v = apply(v, horiz_ops[i][0], numbers[i][1]);
      if (isNaN(v) || v <= 0) {
        valid = false;
        break;
      }
      v = apply(v, horiz_ops[i][1], numbers[i][2]);
      if (isNaN(v) || v <= 0) {
        valid = false;
        break;
      }
      targets_h.push(v);
    }
    if (!valid) continue;

    const targets_v = [];
    for (let j = 0; j < 3; j++) {
      let v = numbers[0][j];
      v = apply(v, vert_ops[0][j], numbers[1][j]);
      if (isNaN(v) || v <= 0) {
        valid = false;
        break;
      }
      v = apply(v, vert_ops[1][j], numbers[2][j]);
      if (isNaN(v) || v <= 0) {
        valid = false;
        break;
      }
      targets_v.push(v);
    }
    if (valid) {
      return { horiz_ops, vert_ops, targets_h, targets_v };
    }
  }
  console.warn('Não encontrou puzzle válido, usando padrão');
  return {
    horiz_ops: [["+", "+"], ["-", "-"], ["×", "×"]],
    vert_ops: [["+", "-", "×"], ["-", "×", "+"]],
    targets_h: [10, 5, 12],
    targets_v: [8, 6, 9]
  };
};

const CrossMathGame = ({ difficulty, onBack, addPoints }) => {
  const [puzzle, setPuzzle] = useState(null);
  const [inputs, setInputs] = useState([["", "", ""], ["", "", ""], ["", "", ""]]);
  const [finished, setFinished] = useState(false);
  const [msg, setMsg] = useState("");
  const seconds = LEVEL_CONFIG[difficulty].seconds;

  useEffect(() => {
    const newPuzzle = generatePuzzle(difficulty);
    setPuzzle(newPuzzle);
    setInputs([["", "", ""], ["", "", ""], ["", "", ""]]);
    setMsg("");
    setFinished(false);
  }, [difficulty]);

  const onTimeUp = () => {
    setFinished(true);
    setMsg("⏰ Tempo esgotado!");
  };

  const updateInput = (r, c, value) => {
    const val = value.replace(/[^1-9]/g, '').slice(-1);
    setInputs(prev => {
      const newInputs = prev.map(row => row.slice());
      newInputs[r][c] = val;
      return newInputs;
    });
  };

  const check = () => {
    if (finished) return;
    const flat = inputs.flat();
    if (flat.some(v => v === '') || new Set(flat).size < 9) {
      setMsg("❌ Preencha com 1-9 sem repetições!");
      return;
    }

    let valid = true;
    for (let i = 0; i < 3; i++) {
      let v = parseInt(inputs[i][0]);
      v = apply(v, puzzle.horiz_ops[i][0], parseInt(inputs[i][1]));
      if (isNaN(v)) {
        valid = false;
        break;
      }
      v = apply(v, puzzle.horiz_ops[i][1], parseInt(inputs[i][2]));
      if (isNaN(v) || v !== puzzle.targets_h[i]) {
        valid = false;
        break;
      }
    }
    if (!valid) {
      setMsg("❌ Equações horizontais incorretas!");
      return;
    }

    for (let j = 0; j < 3; j) {
      let v = parseInt(inputs[0][j]);
      v = apply(v, puzzle.vert_ops[0][j], parseInt(inputs[1][j]));
      if (isNaN(v)) {
        valid = false;
        break;
      }
      v = apply(v, puzzle.vert_ops[1][j], parseInt(inputs[2][j]));
      if (isNaN(v) || v !== puzzle.targets_v[j]) {
        valid = false;
        break;
      }
    }
    if (!valid) {
      setMsg("❌ Equações verticais incorretas!");
      return;
    }

    const points = 10 * LEVEL_CONFIG[difficulty].items;
    setMsg("✅ Correto! + " + points + " pontos");
    addPoints(points);
    saveToRanking(points);
    setFinished(true);
  };

  if (!puzzle) return <div>Carregando...</div>;

  return (
    <div className="game">
      <h3>➕ CrossMath — {DIFFICULTY_LABEL[difficulty]}</h3>
      <Timer seconds={seconds} onTimeUp={onTimeUp} isRunning={!finished} />
      {!finished ? (
        <>
          <div className="crossmath-grid">
            <div className="gm-row">
              <input value={inputs[0][0]} onChange={(e) => updateInput(0, 0, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[0][0]}</span>
              <input value={inputs[0][1]} onChange={(e) => updateInput(0, 1, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[0][1]}</span>
              <input value={inputs[0][2]} onChange={(e) => updateInput(0, 2, e.target.value)} maxLength={1} />
              <span>=</span>
              <span className="target">{puzzle.targets_h[0]}</span>
            </div>
            <div className="gm-row">
              <span>{puzzle.vert_ops[0][0]}</span>
              <span className="empty"></span>
              <span>{puzzle.vert_ops[0][1]}</span>
              <span className="empty"></span>
              <span>{puzzle.vert_ops[0][2]}</span>
              <span className="empty"></span>
              <span className="empty"></span>
            </div>
            <div className="gm-row">
              <input value={inputs[1][0]} onChange={(e) => updateInput(1, 0, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[1][0]}</span>
              <input value={inputs[1][1]} onChange={(e) => updateInput(1, 1, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[1][1]}</span>
              <input value={inputs[1][2]} onChange={(e) => updateInput(1, 2, e.target.value)} maxLength={1} />
              <span>=</span>
              <span className="target">{puzzle.targets_h[1]}</span>
            </div>
            <div className="gm-row">
              <span>{puzzle.vert_ops[1][0]}</span>
              <span className="empty"></span>
              <span>{puzzle.vert_ops[1][1]}</span>
              <span className="empty"></span>
              <span>{puzzle.vert_ops[1][2]}</span>
              <span className="empty"></span>
              <span className="empty"></span>
            </div>
            <div className="gm-row">
              <input value={inputs[2][0]} onChange={(e) => updateInput(2, 0, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[2][0]}</span>
              <input value={inputs[2][1]} onChange={(e) => updateInput(2, 1, e.target.value)} maxLength={1} />
              <span>{puzzle.horiz_ops[2][1]}</span>
              <input value={inputs[2][2]} onChange={(e) => updateInput(2, 2, e.target.value)} maxLength={1} />
              <span>=</span>
              <span className="target">{puzzle.targets_h[2]}</span>
            </div>
          </div>
          <div className="vert-targets">
            <span>= {puzzle.targets_v[0]}</span>
            <span>= {puzzle.targets_v[1]}</span>
            <span>= {puzzle.targets_v[2]}</span>
          </div>
          <button onClick={check} className="btn red">Verificar</button>
          <p>{msg}</p>
        </>
      ) : (
        <>
          <p>{msg}</p>
          <button className="btn gray" onClick={onBack}>⬅ Voltar ao menu</button>
        </>
      )}
    </div>
  );
};

// ========================== 4) RANKING ==========================
const Ranking = ({ onBack }) => {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("ranking") || "[]");
    const scores = {};
    data.forEach((r) => { scores[r.name] = (scores[r.name] || 0) + r.points; });
    const sorted = Object.entries(scores)
      .map(([name, points]) => ({ name, points }))
      .sort((a, b) => b.points - a.points)
      .slice(0, 10);
    setRanking(sorted);
  }, []);

  return (
    <div className="game">
      <h3>🏆 Ranking</h3>
      <ol>
        {ranking.map((r, i) => (
          <li key={i}><b>{i + 1}. {r.name}</b> — {r.points} pts</li>
        ))}
      </ol>
      <button onClick={onBack} className="back-btn">⬅ Voltar</button>
    </div>
  );
};

// ========================== PÁGINA PRINCIPAL ==========================
const Jogos = () => {
  const [game, setGame] = useState(null);
  const [difficulty, setDifficulty] = useState("facil");
  const [score, setScore] = useState(0);

  useEffect(() => {
    const saved = localStorage.getItem("score");
    if (saved) setScore(parseInt(saved));
  }, []);

  useEffect(() => { localStorage.setItem("score", score); }, [score]);

  const addPoints = (points) => setScore((prev) => prev + points);

  return (
    <div>
      <Header />
      <section className="jogos-section">
        <div className="container">
          {game === "anagram" && (
            <AnagramGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
          )}
          {game === "crossword" && (
            <CrosswordGameWrapper difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
          )}
          {game === "crossmath" && (
            <CrossMathGame difficulty={difficulty} onBack={() => setGame(null)} addPoints={addPoints} />
          )}
          {game === "ranking" && <Ranking onBack={() => setGame(null)} />}
          {!game && (
            <GameMenu
              setGame={setGame}
              setDifficulty={setDifficulty}
              difficulty={difficulty}
              score={score}
            />
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Jogos;